import React, { Component } from "react";
import PropTypes from "prop-types";
import "../theme/header.css";

class Header extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired
  };
  render() {
    const { title, subtitle } = this.props;
    return (
      <header>
        <img src={require("../images/logo_med.png")} alt="Mucky Duck" />
        <div style={{ display: "flex", flexDirection: "column" }}>
          <h1>{title}</h1>
          <h2>{subtitle}</h2>
        </div>
      </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js